/*

  _____ _ _      _
  /  ___| (_)    | |
  \ `--.| |_  ___| | _____ _ __
  `--. \ | |/ __| |/ / _ \ '__|
  /\__/ / | | (__|   <  __/ |
  \____/|_|_|\___|_|\_\___|_|

  THIS IS A WRAPPER FOR THE slick-carousel Library.
  http://kenwheeler.github.io/slick/

  THE MAIN GOAL OF THIS INTERFACE IS TO CREATE A CONSISTENT NAVIGATION FOR THE CAROUSELS ( aka sliders ).
  THE CONSTRUCTOR OPTIONS ARE THE SAME AS slick , however we have aded the convenience of supporting:

  initFunction: gets called when slider Initializies
  beforeFunction: called before a slide change
  afterFunction: called after slide change.

  dburns@fiveanddone.com

  Note: slicked options are available via the usual plugin methods, ie:
  var foo = new Slicker({$slider: $(mySlider)})
  var slickOptions = $(mySlider).slick('getSlick')

*/

import $ from 'jquery';
import '../vendor/slick/slick.1.8.1';

var Slicker = function Slicker(options) {
  /*
  Should there be a way to just use .slick defaults, and
  instead of requiring options.$slider & options.slickOptions with new Slicker()?
  or in that case... would we just use $(ele).slick anyway?
  In the meantime, if you DO use var foo = new Slicker($(elem)), this will pass along the defaults
  */
  if (!options.$slider) {
    this.$slider = $(options).not('.slick-initialized');
    this.slickOptions = {};
    this.slickify();
    return;
  }


  this.ww = 0;
  // DEFAULTS, CAN BE OVERRIDDEN BY USING dots:false AND/OR arrows:false in settings obj.
  this.useDots = true;
  this.useArrows = true;
  this.rows = 0;
  // don't re-select an already initialized slider (noticed this happening in modules dev)
  // fixes add slide = null err. see https://github.com/kenwheeler/slick/issues/1953
  this.$slider = $(options.$slider).not('.slick-initialized');
  // ADD THE DEFAULT NAV CONTAINER.
  var navContainerDiv = '';
  navContainerDiv += ' <div class="slick-nav-container">';
  navContainerDiv += '  <div class="dots-container"></div>';
  navContainerDiv += '</div>';
  // add special class to add special properties to container passed in.
  this.$slider.append(navContainerDiv);
  options.slickOptions.$slider = this.$slider; // pass along current $slider for use by options config

  // provide custom paginator via our wrapper in order to output datalayer-link classes
  // note: ADA attributes should take place here, not in the plugin file.
  // Added aria-label-sample attr as sample. Modified plugin still does its thing
  options.slickOptions.customPaging = function (slider, i) {
    var ariaLabel = (i + 1) + ' of ' + slider.slideCount;
    var $el = $('<button type="button" data-from="slicker-customPaging" class="datalayer-link-slick-dot" aria-label-sample="' + ariaLabel + '" />').text(i + 1);
    // todo: import analytics blocks here instead of adding as anctx directly. yes?
    $el.data({
      linktext: 'pagination'
    });
    return $el;
  };

  this.slickOptions = this.processSlickOptions(options.slickOptions);
  if (options.slickOptions.paddingBottom) {
    this.$slider.css('padding-bottom', options.slickOptions.paddingBottom); // CONFIGURABLE via OPTIONS.
  }
  this.init();
};


Slicker.prototype = {
  processDefaults: function (optionsObj) {
    // defaults, if not provided via slickOptions obj
    var usedots = true;
    var usearrows = true;
    var nextArrow = '<button class="slick-next-btn datalayer-link" data-linktext="next"><i class="icon icon-arrow-thin-right"></i></button>';
    var prevArrow = '<button class="slick-prev-btn datalayer-link" data-linktext="previous"><i class="icon icon-arrow-thin-left"></i></button>';
    var appendDots = $(optionsObj.$slider).find('.slick-nav-container .dots-container');
    var appendArrows = $(optionsObj.$slider).find('.slick-nav-container');
    /*
    Alter the default of rows = 1, as seen in Slick
    to rows = 0, due to breaking change: https://github.com/kenwheeler/slick/commit/34612b42641e8fd4250f70666a8da67eb624d002
    allow us to specify rows via Slicker, if so desired
    */
    var rows = 0;
    for (var prop in optionsObj) {
      if (prop === 'dots') {
        usedots = optionsObj['dots'];
      }
      if (prop === 'arrows') {
        usearrows = optionsObj['arrows'];
      }
      if (prop === 'nextArrow') {
        nextArrow = optionsObj['nextArrow'];
      }
      if (prop === 'prevArrow') {
        prevArrow = optionsObj['prevArrow'];
      }
      if (prop === 'appendDots') {
        appendDots = optionsObj['appendDots'];
      }
      if (prop === 'appendArrows') {
        appendArrows = optionsObj['appendArrows'];
      }
      if (prop === 'rows') {
        rows = optionsObj['rows'];
      }
    }
    optionsObj.dots = usedots;
    optionsObj.arrows = usearrows;
    optionsObj.rows = rows;
    optionsObj.nextArrow = nextArrow;
    optionsObj.prevArrow = prevArrow;
    optionsObj.appendDots = appendDots;
    optionsObj.appendArrows = appendArrows;

    // iterate over top LEVEL

    // do responsive settings:
    // /*
    if (optionsObj.responsive && optionsObj.responsive.length) {
      var count = 0;
      // console.log(' PROCESS RESPONSIVE DEFAULTS:', optionsObj.responsive);
      // for(var i = 0; i > optionsObj.responsive.length; i++){
      // console.log(' TICK ', i);
      for (var item in optionsObj.responsive) {
        var responsiveItem = optionsObj.responsive[count];
        // console.log(' ::: responsiveItem', responsiveItem);


        if (responsiveItem && responsiveItem['settings']) {
          var rusedots = true;
          var rusearrows = true;

          var rsettings = responsiveItem['settings'];
          // console.log(':: rsettings', rsettings);
          for (var rprop in rsettings) {
            // console.log('   ::: rprop [' +  rprop + ']')
            if (rprop === 'dots') {
              rusedots = rsettings[rprop];
            }
            if (rprop === 'arrows') {
              rusearrows = rsettings[rprop];
            }
          }
          rsettings.dots = rusedots;
          rsettings.arrows = rusearrows;
        }
        count ++;
      }
      // console.log(' SETTINGS AFTER ', rsettings )
    }
    // */
  },
  processSlickOptions: function (options) {
    /*
      RECONFIGURE OPTIONS TO SUPPORT THE EXISTING CONSTRUCTOR PARAMETERS USED FOR BX SLIDER.
      SHOULD ALLOW FOR 'QUICKER' MIGRATION.
    */

    var newOptions = {};
    if (options.desktop || options.tablet || options.phone) {
      newOptions.responsive = [];
    }

    Object.keys(options).forEach((prop) => {
      if (prop === 'phone' || prop === 'tablet' || prop === 'desktop') {
        let breakpoint;
        switch (prop) {
          case 'phone':
            breakpoint = 479;
            break;
          case 'tablet':
            breakpoint = 767;
            break;
          case 'desktop':
            breakpoint = 959;
            break;
          default:
            breakpoint = 959;
            break;
        }
        newOptions.responsive.push({
          settings: options[prop],
          breakpoint: breakpoint,
        });
      } else {
        newOptions[prop] = options[prop];
      }
    });
    // console.log(':::: newOptions', newOptions);
    this.processDefaults(newOptions);
    return newOptions;
  },

  init: function () {
    var self = this;
    if (self.$slider.length > 0) {
      self.slickify();
    }

    $(window).on('breakpoint', function () {
      self.ww = window.innerWidth;
    });
  },

  slickify: function () {
    var self = this;
    // console.log('  ::::SLICKIFY', self);
    self.slider = self.$slider.slick(self.slickOptions);
    self.ww = window.innerWidth;
    // console.log('ww',self.ww)
    var hasResponsiveOptions = (self.slickOptions.responsive && self.slickOptions.responsive.length);
    // console.log('hasResponsiveOptions:', hasResponsiveOptions, '\nww:', self.ww);
    // DEFAULT EVENTS AND METHODS THAT USERS CAN SUBSRCIBE TO BY PROVIDING CALLBACKS.
    var getCallback = function (type) {
      var breakpointKey = 480;

      if (self.ww < 480) {
        breakpointKey = 480;
      }
      if (self.ww > 480 && self.ww < 768) {
        breakpointKey = 768;
      }
      if (self.ww >= 960) {
        breakpointKey = 960;
      }
      var ret = null;
      if (hasResponsiveOptions) {
        for (var k = 0; k < self.slickOptions.responsive.length; k++) {
          var breakpointSettings = self.slickOptions.responsive[k];
          if (breakpointSettings.breakpoint === breakpointKey && breakpointSettings.settings[type]) {
            ret = breakpointSettings.settings[type];
          }
        }
      } else {
        if (self.slickOptions[type]) {
          ret = self.slickOptions[type];
        }
      }

      return ret;
    };

    // CALL INIT CB FUNCTION IF PRESENT ON BASIC OR RESPONSIVE SETTINGS OBJECTS.
    var hasInitCB = !!getCallback('initFunction') || !!self.slickOptions.initFunction;
    if (hasInitCB) {
      self.slider.init(function () {
        // console.log('	:::  SLICKER slickify INIT :::');
        var initCB = getCallback('initFunction') || self.slickOptions.initFunction;
        initCB.apply(null, []);
      });
    }

    // CALL onBefore CB FUNCTION IF PRESENT ON BASIC OR RESPONSIVE SETTINGS OBJECTS.
    var hasBeforeCB = !!getCallback('beforeFunction') || !!self.slickOptions.beforeFunction;
    if (hasBeforeCB) {
      self.slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var beforeCB = getCallback('beforeFunction') || self.slickOptions.beforeFunction;
        // Return all that default slick would return
        beforeCB.apply(null, [event, slick, currentSlide, nextSlide]);
      });
    }

    // CALL onAfter CB FUNCTION IF PRESENT ON BASIC OR RESPONSIVE SETTINGS OBJECTS.
    var hasAfterCB = !!getCallback('afterFunction') || !!self.slickOptions.afterFunction;
    if (hasAfterCB) {
      self.slider.on('afterChange', function (event, slick, currentSlide) {
        var afterCB = getCallback('afterFunction') || self.slickOptions.afterFunction;
        // Return all that default slick would return
        afterCB.apply(null, [event, slick, currentSlide]);
      });
    }

    // CALL onAfter CB FUNCTION IF PRESENT ON BASIC OR RESPONSIVE SETTINGS OBJECTS.
    var hasDestroyCB = !!getCallback('destroyFunction') || !!self.slickOptions.destroyFunction;
    self.slider.on('destroy', function (event, slick) {
      $(self.slider).find('.slick-nav-container').remove(); // always remove the default appendArrows here too (see vehicle info destroyFunction where we need to do this)
    });
    if (hasDestroyCB) {
      self.slider.on('destroy', function (event, slick) {
        var destroyCB = getCallback('destroyFunction') || self.slickOptions.destroyFunction;
        // Return all that default slick would return
        destroyCB.apply(null, [event, slick]);
        $(self.slider).off('destroy'); // destroy event would remain on reInit'ed slideshow if we didn't remove it first
      });
    }
  }
};

export default Slicker;
